/*
 * @Author: your name
 * @Date: 2020-11-10 10:22:38
 * @LastEditTime: 2020-12-29 11:05:51
 * @LastEditors: 郭德纲
 * @Description: dashborad接口
 * @FilePath: \ccb-web\src\common\api.js
 */
import http from '../../common/http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
const resquest = '1.1/functions'
const baseURL = 'https://overdue.moshouapp.com'

// post请求 https://overdue.moshouapp.com/1.1/functions/webComment
export function getCommentAPI() {
  return http.post({ url: `${resquest}/webComment`, baseURL: baseURL })

}

